export const getTimeCategoryId = (
  date: Date
): string | { month: string; year: number | null } => {
  const today = new Date();
  const yesterday = new Date();
  yesterday.setDate(today.getDate() - 1);

  if (date.toDateString() === today.toDateString()) {
    return 'Today';
  } else if (date.toDateString() === yesterday.toDateString()) {
    return 'Yesterday';
  } else if (
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
  ) {
    return 'This month';
  }
  const month = date.toLocaleString('default', { month: 'long' });
  const year =
    date.getFullYear() !== today.getFullYear() ? date.getFullYear() : null;
  return { month, year };
};
